import { useEffect } from "react";
import { DATA_LAYER_SEARCH_TYPE } from "client/utils/constants";
import { AutosuggestDataLayer } from "types/custom";

export const useTrackingDataLayer = () => {
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      typeof window.mergeIntoDataLayer === "function"
    ) {
      const searchType =
        sessionStorage && sessionStorage.getItem(DATA_LAYER_SEARCH_TYPE);

      if (searchType) {
        window.mergeIntoDataLayer(
          JSON.parse(searchType) as AutosuggestDataLayer,
        );
        sessionStorage.removeItem(DATA_LAYER_SEARCH_TYPE);
      }
    }
  }, []);
};
